import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import type { FeatureAnnouncement } from '../models';
import { FEATURE_ANNOUNCEMENTS_MANIFEST_URL } from './feature-announcement-manifest-url.token';

@Injectable({ providedIn: 'root' })
export class FeatureAnnouncementManifestService {
  private readonly http = inject(HttpClient);
  private readonly manifestUrl = inject(FEATURE_ANNOUNCEMENTS_MANIFEST_URL);

  getManifest(): Observable<FeatureAnnouncement[]> {
    return this.http.get<FeatureAnnouncement[]>(this.manifestUrl);
  }
}
